<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="rateForm">
        <v-layout row wrap>
          <v-flex row xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
            <div class="title">{{this.ids.planNo}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.busCls}}</v-subheader>
            <div class="title">{{this.ids.busCls}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.tarf}}</v-subheader>
            <div class="title">{{this.ids.tarf}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs4 v-if="checkFactor(factorList.fact1) && newRate === false">
            <v-subheader class="queryLabel">{{labels.fact1}}</v-subheader>
            <div class="title">{{rateForm.fact1}}</div>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact1) && newRate === true">
            <v-text-field data-vv-scope="rateForm" v-model="rateForm.fact1" :label="labels.fact1 + '*'" :error-messages="errors.collect('rateForm.fact1')" data-vv-name="rateForm.fact1" :data-vv-as="labels.fact1" v-validate="'param|max:8|required'"></v-text-field>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact2) && newRate === false">
            <v-subheader class="queryLabel">{{labels.fact2}}</v-subheader>
            <div class="title">{{rateForm.fact2}}</div>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact2) && newRate === true">
            <v-text-field data-vv-scope="rateForm" v-model="rateForm.fact2" :label="labels.fact2 + '*'" :error-messages="errors.collect('rateForm.fact1')" data-vv-name="rateForm.fact2" :data-vv-as="labels.fact2" v-validate="'param|max:8|required'"></v-text-field>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact3) && newRate === false">
            <v-subheader class="queryLabel">{{labels.fact3}}</v-subheader>
            <div class="title">{{rateForm.fact3}}</div>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact3) && newRate === true">
            <v-text-field data-vv-scope="rateForm" v-model="rateForm.fact3" :label="labels.fact3 + '*'" :error-messages="errors.collect('rateForm.fact3')" data-vv-name="rateForm.fact3" :data-vv-as="labels.fact3" v-validate="'param|max:8|required'"></v-text-field>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact4) && newRate === false">
            <v-subheader class="queryLabel">{{labels.fact4}}</v-subheader>
            <div class="title">{{rateForm.fact4}}</div>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact4) && newRate === true">
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 10, decScale: 2}" v-model="rateForm.fact4" :label="labels.fact4 + '*'" :error-messages="errors.collect('rateForm.fact4')" data-vv-name="rateForm.fact4" :data-vv-as="labels.fact4" v-validate="'required'"></v-text-field>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact5) && newRate === false">
            <v-subheader class="queryLabel">{{labels.fact5}}</v-subheader>
            <div class="title">{{rateForm.fact5}}</div>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact5) && newRate === true">
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 10, decScale: 2}" v-model="rateForm.fact5" :label="labels.fact5 + '*'" :error-messages="errors.collect('rateForm.fact5')" data-vv-name="rateForm.fact5" :data-vv-as="labels.fact5" v-validate="'required'"></v-text-field>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact6) && newRate === false">
            <v-subheader class="queryLabel">{{labels.fact6}}</v-subheader>
            <div class="title">{{rateForm.fact6}}</div>
          </v-flex>
          <v-flex xs4 v-if="checkFactor(factorList.fact6) && newRate === true">
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 10, decScale: 2}" v-model="rateForm.fact6" :label="labels.fact6 + '*'" :error-messages="errors.collect('rateForm.fact6')" data-vv-name="rateForm.fact6" :data-vv-as="labels.fact6" v-validate="'required'"></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs6 v-if="newRate">
            <cal-picker data-vv-scope="rateForm" :label="labels.effDate" v-model="rateForm.effDate" :error-messages="errors.collect('rateForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.expDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker data-vv-scope="rateForm" :label="labels.effDate" v-model="rateForm.effDate" :error-messages="errors.collect('rateForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.expDate" readonly></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker data-vv-scope="rateForm" :label="labels.expDate" v-model="rateForm.expDate" :error-messages="errors.collect('rateForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate"></cal-picker>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="rateForm.minAp" :label="labels.minAp" :error-messages="errors.collect('rateForm.minAp')" data-vv-name="minAp" :data-vv-as="labels.minAp" v-validate="maxValidation(rateForm.maxAp)"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="rateForm.maxAp" :label="labels.maxAp" :error-messages="errors.collect('rateForm.maxAp')" data-vv-name="maxAp" :data-vv-as="labels.maxAp" v-validate="minValidation(rateForm.minAp)"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="rateForm.baseAp" :label="labels.baseAp" :error-messages="errors.collect('rateForm.baseAp')" data-vv-name="baseAp" :data-vv-as="labels.baseAp"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 6, decScale: 3}" v-model="rateForm.pctIncBaseAp" :label="labels.pctIncBaseAp" :error-messages="errors.collect('rateForm.pctIncBaseAp')" data-vv-name="pctIncBaseAp" :data-vv-as="labels.pctIncBaseAp"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="rateForm.incApbase" :label="labels.incApbase" :error-messages="errors.collect('rateForm.incApbase')" data-vv-name="incApbase" :data-vv-as="labels.incApbase"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="rateForm.baseSi" :label="labels.baseSi" :error-messages="errors.collect('rateForm.baseSi')" data-vv-name="baseSi" :data-vv-as="labels.baseSi"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="rateForm" v-num-mask="{negative: true, intScale: 10, decScale: 2}" v-model="rateForm.incSi" :label="labels.incSi" :error-messages="errors.collect('rateForm.incSi')" data-vv-name="incSi" :data-vv-as="labels.incSi"></v-text-field>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveRateForm">
        {{newRate ? 'Save Rate' : 'Update Rates'}}
        <v-icon right>{{newRate ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      rateForm: {
        busCls: null,
        tarf: null,
        benefit: null,
        effDate: null,
        seqNo: null,
        expDate: null,
        tarfRate: 0.00,
        minAp: 0.00,
        maxAp: 0.00,
        baseAp: 0.00,
        baseSi: 0.00,
        pctIncBaseAp: 0.00,
        incSi: 0.00,
        incApbase: 0.00,
        fact1: 'NA',
        fact2: 'NA',
        fact3: 'NA',
        fact4: 0.00,
        fact5: 0.00,
        fact6: 0.00
      },
      labels: {
        scheme: 'Scheme',
        planNo: 'Plan No',
        busCls: 'Business Class',
        tarf: 'Tariff',
        seqNo: 'Sequence',
        effDate: 'Effective Date*',
        expDate: 'Expired Date',
        minAp: 'Min Annual Premium',
        maxAp: 'Max Annual Premium',
        baseAp: 'Base Annual Premium',
        baseSi: 'Base Sum Insured',
        pctIncBaseAp: '% Increase Base Annual Premium',
        incSi: 'Increase Sum Insured',
        incApbase: 'Increase Annual Premium Base',
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null
      },
      submitting: false,
      newRate: null,
      factNumList: [],
      factStringList: []
    }
  },
  computed: {
    pkgTarfBenMenu() {
      return this.$store.state.parameters.scheme.pkgTarfBenMenu
    },
    pkgTarfFactMenu() {
      return this.$store.state.parameters.scheme.pkgTarfFactMenu
    },
    factorList() {
      return this.$store.state.parameters.scheme.pkgTarfFactMenu.factor
    }
  },
  watch: {
    'ids.rateEffDate': function(value) {
      Promise.all([this.doFactorInit()])
      if (value !== 'new') {
        this.resetValidator()
        this.resetMessages()
        this.newRate = false
        this.fetchForm(value)
      } else {
        this.newRate = true
        this.doClearForm()
      }
    },
    'rateForm.minAp': function (value) {
      this.minValidation(value)
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'mask_max_value:' + max
    },
    async fetchForm(effDate) {
      if (this.ids.rateEffDate != null) {
        const apiURI = this.pkgTarfFactMenu.menu.pkgTarfRate
        if (apiURI) {
          try {
            const expand = {
              scheme: this.ids.scheme,
              planNo: this.ids.planNo,
              busCls: this.ids.busCls,
              tarf: this.ids.tarf,
              benefit: this.ids.benefit,
              seqNo: this.ids.seqNo,
              fact1: this.ids.fact1,
              fact2: this.ids.fact2,
              fact3: this.ids.fact3,
              fact4: this.ids.fact4,
              fact5: this.ids.fact5,
              fact6: this.ids.fact6,
              effDate: this.ids.rateEffDate
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.rateForm.scheme = this.ids.scheme
              this.rateForm.planNo = this.ids.planNo
              this.rateForm.tarf = this.ids.tarf
              this.rateForm.busCls = this.ids.busCls
              this.rateForm.benefit = this.ids.benefit
              this.rateForm.seqNo = data.pkgTarfRate.seqNo
              this.rateForm.effDate = data.pkgTarfRate.effDate
              this.rateForm.expDate = data.pkgTarfRate.expDate
              this.rateForm.fact1 = data.pkgTarfRate.fact1
              this.rateForm.fact2 = data.pkgTarfRate.fact2
              this.rateForm.fact3 = data.pkgTarfRate.fact3
              this.rateForm.fact4 = data.pkgTarfRate.fact4
              this.rateForm.fact5 = data.pkgTarfRate.fact5
              this.rateForm.fact6 = data.pkgTarfRate.fact6
              this.rateForm.minAp = formatDisplayNumber(data.pkgTarfRate.minAp)
              this.rateForm.maxAp = formatDisplayNumber(data.pkgTarfRate.maxAp)
              this.rateForm.baseAp = formatDisplayNumber(data.pkgTarfRate.baseAp)
              this.rateForm.baseSi = formatDisplayNumber(data.pkgTarfRate.baseSi)
              this.rateForm.pctIncBaseAp = formatDisplayNumber(data.pkgTarfRate.pctIncBaseAp)
              this.rateForm.incSi = formatDisplayNumber(data.pkgTarfRate.incSi)
              this.rateForm.incApbase = formatDisplayNumber(data.pkgTarfRate.incApbase)

              this.menu = extractMenu(result.data._links)
            }
          } catch (err) {
            console.log(err)
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('Invalid API Url')
        }
      }
    },
    factStringSearch(fact) {
      if (fact === null) {
        return null
      } else if (fact === undefined) {
        return null
      } else {
        var found = this.factStringList.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    factNumSearch(fact) {
      if (fact === null) {
        return null
      } else if (fact === undefined) {
        return null
      } else {
        var found = this.factNumList.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    async doFactorInit() {
      const apiURI = this.pkgTarfBenMenu.menu.factorList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            if (this.factNumList > 0) {
              this.factNumList = []
            }
            if (this.factStringList > 0) {
              this.factStringList = []
            }
            this.factStringList = await data.factStringList
            this.factNumList = await data.factNumList
            this.labels.fact1 = this.factStringSearch(this.factorList.fact1)
            this.labels.fact2 = this.factStringSearch(this.factorList.fact2)
            this.labels.fact3 = this.factStringSearch(this.factorList.fact3)
            this.labels.fact4 = this.factNumSearch(this.factorList.fact4)
            this.labels.fact5 = this.factNumSearch(this.factorList.fact5)
            this.labels.fact6 = this.factNumSearch(this.factorList.fact6)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - factor List')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.rateForm.scheme = this.ids.scheme
      this.rateForm.planNo = this.ids.planNo
      this.rateForm.busCls = this.ids.busCls
      this.rateForm.tarf = this.ids.tarf
      this.rateForm.benefit = this.ids.benefit
      this.rateForm.effDate = null
      this.rateForm.seqNo = this.ids.seqNo
      this.rateForm.expDate = null
      this.rateForm.tarfRate = 0.00
      this.rateForm.minAp = 0.00
      this.rateForm.maxAp = 0.00
      this.rateForm.baseAp = 0.00
      this.rateForm.baseSi = 0.00
      this.rateForm.pctIncBaseAp = 0.00
      this.rateForm.incSi = 0.00
      this.rateForm.incApbase = 0.00
      this.rateForm.fact1 = 'NA'
      this.rateForm.fact2 = 'NA'
      this.rateForm.fact3 = 'NA'
      this.rateForm.fact4 = 0.00
      this.rateForm.fact5 = 0.00
      this.rateForm.fact6 = 0.00
    },
    doSaveRateForm() {
      this.resetMessages()
      this.$validator.validateAll('rateForm').then(result => {
        if (result) {
          if (this.newRate) {
            this.doCreateRateForm()
          } else {
            this.doUpdateRateForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateRateForm() {
      const apiURI = this.pkgTarfFactMenu.menu.pkgTarfRateCreate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.rateForm.scheme,
            planNo: this.rateForm.planNo,
            busCls: this.rateForm.busCls,
            tarf: this.rateForm.tarf,
            benefit: this.rateForm.benefit,
            effDate: this.rateForm.effDate,
            seqNo: this.rateForm.seqNo,
            expDate: this.rateForm.expDate,
            tarfRate: removeFormatNumber(this.rateForm.tarfRate),
            minAp: removeFormatNumber(this.rateForm.minAp),
            maxAp: removeFormatNumber(this.rateForm.maxAp),
            baseAp: removeFormatNumber(this.rateForm.baseAp),
            baseSi: removeFormatNumber(this.rateForm.baseSi),
            pctIncBaseAp: removeFormatNumber(this.rateForm.pctIncBaseAp),
            incSi: removeFormatNumber(this.rateForm.incSi),
            incApbase: removeFormatNumber(this.rateForm.incApbase),
            fact1: removeFormatNumber(this.rateForm.fact1),
            fact2: removeFormatNumber(this.rateForm.fact2),
            fact3: removeFormatNumber(this.rateForm.fact3),
            fact4: removeFormatNumber(this.rateForm.fact4),
            fact5: removeFormatNumber(this.rateForm.fact5),
            fact6: removeFormatNumber(this.rateForm.fact6)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 3)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Rate create')
      }
    },
    async doUpdateRateForm() {
      const apiURI = this.menu.pkgTarfRateUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.rateForm.scheme,
            planNo: this.rateForm.planNo,
            busCls: this.rateForm.busCls,
            tarf: this.rateForm.tarf,
            benefit: this.rateForm.benefit,
            effDate: this.rateForm.effDate,
            seqNo: this.rateForm.seqNo,
            expDate: this.rateForm.expDate,
            tarfRate: removeFormatNumber(this.rateForm.tarfRate),
            minAp: removeFormatNumber(this.rateForm.minAp),
            maxAp: removeFormatNumber(this.rateForm.maxAp),
            baseAp: removeFormatNumber(this.rateForm.baseAp),
            baseSi: removeFormatNumber(this.rateForm.baseSi),
            pctIncBaseAp: removeFormatNumber(this.rateForm.pctIncBaseAp),
            incSi: removeFormatNumber(this.rateForm.incSi),
            incApbase: removeFormatNumber(this.rateForm.incApbase),
            fact1: removeFormatNumber(this.rateForm.fact1),
            fact2: removeFormatNumber(this.rateForm.fact2),
            fact3: removeFormatNumber(this.rateForm.fact3),
            fact4: removeFormatNumber(this.rateForm.fact4),
            fact5: removeFormatNumber(this.rateForm.fact5),
            fact6: removeFormatNumber(this.rateForm.fact6)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 3)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    checkFactor(value) {
      if (value === undefined) {
        return false
      } if (value === null) {
        return false
      } else {
        return true
      }
    }
  },
  mounted() {
    if (this.newBenefit) {
      this.doClearForm()
    }
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          planNo: null,
          busCls: null,
          tarf: null,
          benefit: null,
          benEffDate: null,
          seqNo: null,
          factEffDate: null,
          rateEffDate: null,
          fact1: 'NA',
          fact2: 'NA',
          fact3: 'NA',
          fact4: 0.00,
          fact5: 0.00,
          fact6: 0.00
        }
      }
    }
  },
  mixins: [
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>
</style>
